var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Dashboard } from './dashboard/dashboard';
import { StationContainer } from './stations/container';
import { Auth, login } from './login';
import { MapLibreOverlay } from './overlay';
import { MapLibre } from './maplibre/map';
import C from './common/C';
import './map.scss';
function main() {
    return __awaiter(this, void 0, void 0, function () {
        var spinner, dashboard, mapLibre, auth;
        return __generator(this, function (_a) {
            spinner = C.select('#loading-spinner');
            dashboard = new Dashboard(C.select('#dashboard'), spinner);
            mapLibre = new MapLibre();
            auth = new Auth();
            spinner.show();
            login().then(function (xauth) {
                auth.setToken(xauth.getToken());
                spinner.hide();
                dashboard.setUser(auth);
            });
            mapLibre.loaded().then(function (map) {
                var stations = new StationContainer(auth, map, dashboard);
                var overlay = new MapLibreOverlay(map, stations);
                stations.setOverlay(overlay);
                dashboard
                    .setView(stations)
                    .setRouter(mapLibre.router)
                    .selectSpecie(mapLibre.router.specie() || 'pm25')
                    .then(function (_) {
                    // Find the station with the worst AQI
                    var worstStation = stations.findWorstStation();
                    if (!worstStation)
                        return;
                    dashboard.highlight([worstStation]);
                });
                login().then(function (_) {
                    var timeControl = mapLibre.showTemporalControl(function () {
                        return stations.loader
                            .fetchHistoric(dashboard.activeSpecie)
                            .then(function (tsmap) {
                            var frames = tsmap.times().map(function (t, i) { return ({
                                title: new Date(t * 1000).toISOString(),
                                onShow: function () { return stations.updateAQI(tsmap.aqis(t)); },
                            }); });
                            frames.push({
                                title: 'now',
                                onShow: function () { return stations.resetAQI(); },
                            });
                            return frames;
                        });
                    });
                    dashboard.events.subscribe('specie', function (specie) {
                        timeControl.resetLoader();
                    });
                });
            });
            return [2 /*return*/];
        });
    });
}
main();
